exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-flow: column nowrap;\r\n          flex-flow: column nowrap;\r\n  height: 100%;\r\n}\r\n\r\n.toolbar-title {\r\n  margin: 0;\r\n  font-size: 1.1rem;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 1;\r\n          flex: 1 1;\r\n  margin-left: 10px;\r\n  line-height: 40px;\r\n  font-weight: 400;\r\n}\r\n\r\n.cropper {\r\n    width: 100%;\r\n    max-height: 100%;\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 1;\r\n            flex: 1 1;\r\n}\r\n\r\n.cropper >>> .cropper-canvas {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/dialog/crop-dialog/crop-dialog.component.css
// module id = ../../../../../src/app/dialog/crop-dialog/crop-dialog.component.css
// module chunks = 4